import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid ${ColorPalette.HEX.BrightGray};
  background-color: ${({ theme }) => theme.listPreviewCard.white};
  height: fit-content;
`;

export const Group: any = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 8px 16px;
  border-bottom: 1px solid ${ColorPalette.HEX.BrightGray7};
`;

Group.Icon = styled.img`
  width: 23px;
  height: 23px;
  margin-right: 12px;
`;

Group.Title = styled.span`
  line-height: 1.8;
  font-size: 12px;
  font-weight: normal;
  color: ${ColorPalette.HEX.CharlestonGreen};
  max-width: 83%;
`;

Group.ArrowDownIcon = styled(MdKeyboardArrowDown)`
  height: 20px;
  width: 20px;
  color: ${({ theme }) => theme.listPreviewCard.fontColor.empty};
  margin-left: auto;
`;

Group.ArrowUpIcon = styled(MdKeyboardArrowUp)`
  height: 20px;
  width: 20px;
  color: ${({ theme }) => theme.listPreviewCard.fontColor.empty};
  margin-left: auto;
`;

export const AggregateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-bottom: 16px;

  background: linear-gradient(
    0deg,
    rgba(${ColorPalette.RGB.AntiFlashWhite4}, 1) 0%,
    rgba(${ColorPalette.RGB.AntiFlashWhite4}, 1) 84%,
    rgba(${ColorPalette.RGB.Lotion}, 0) 85%,
    rgba(${ColorPalette.RGB.Lotion}, 0) 100%
  );

  & ${Group}:last-child {
    border-bottom: none;
  }

  &:first-child {
    margin-top: 0;
  }

  & ${Container} {
    margin-top: 0 !important;
  }
`;
